import React from 'react';
import { FaFilter, FaPlus } from 'react-icons/fa';
import {
  SearchContainer,
  SearchInput,
  FilterButton,
  AddButton,
} from './CompetitorsStyles';

const SearchAndFilters = ({ onSearch, onFilter, onAddNew }) => {
  return (
    <SearchContainer>
      <SearchInput>
        <input
          type="text"
          placeholder="Buscar competidor, partido o líder…"
          onChange={(e) => onSearch && onSearch(e.target.value)}
        />
      </SearchInput>
      <FilterButton type="button" onClick={onFilter}>
        <FaFilter />
        Filtros
      </FilterButton>
      <AddButton type="button" onClick={onAddNew}>
        <FaPlus />
        Nuevo competidor
      </AddButton>
    </SearchContainer>
  );
};

export default SearchAndFilters;
